import { Paper, Typography } from "@mui/material";
import React from "react";
import { TypeSensor } from '../../pages/camaras/interface/camara.interface';
import { NumericFormat } from 'react-number-format';
import moment from "moment";
import { usePageVisibility } from "../../pages/camaras/usePageVisibility";
import Tooltip from '@mui/material/Tooltip';
import { SensorType } from "../Avanzados/interfaces/avanzado.interface";

type CardProps = {
    propsSensor: TypeSensor;
}

export const SensorComponent: React.FC<CardProps> = ({propsSensor}) => {

    const isPageVisible = usePageVisibility();
    const timerIdRef = React.useRef<NodeJS.Timer | null>(null); 

    const [estado, setEstado] = React.useState<boolean>(true);

    React.useEffect(() => {
        if (moment().diff(propsSensor.valores[0].fecha_hora_value, 'minute') > 5) //Controla que se actualizen los valores
            setEstado(false);
        else
            setEstado(true);


        const controllingCallback = () => {
            if (moment().diff(propsSensor.valores[0].fecha_hora_value, 'minute') > 5) //Controla que se actualizen los valores
                setEstado(false);
            else
                setEstado(true);
        };

        const startPolling = () => {
            timerIdRef.current = setInterval(controllingCallback, 60000); //Cada 1 minuto
        };

        const stopPolling = () => {
            clearInterval(timerIdRef.current!);
        };

        if (isPageVisible) {
            startPolling();
        } else {
            stopPolling();
        }

        return () => {
            stopPolling();
        };

    }, [propsSensor,  isPageVisible]);

    const getValor = (estado: boolean, sensor:TypeSensor) => {
    if (estado)
    {
        switch (sensor.tipo_sensor) {
            case SensorType.TEMPERATURA:
                return <NumericFormat 
                    value={sensor.valores[0].value} 
                    displayType={'text'} 
                    allowNegative 
                    suffix={'°C'} 
                    decimalScale={1}
                    decimalSeparator=","
                    fixedDecimalScale
                />;
            case SensorType.PRESION:
                return <NumericFormat 
                    value={sensor.valores[0].value} 
                    displayType={'text'} 
                    allowNegative 
                    suffix={' Kg'} 
                    decimalScale={1}
                    decimalSeparator=","
                    fixedDecimalScale
                />;
            case SensorType.POTENCIA:
                return <NumericFormat 
                    value={sensor.valores[0].value} 
                    displayType={'text'} 
                    allowNegative 
                    suffix={' KW'} 
                />;
            case SensorType.COSENO_PHI:
                return <NumericFormat 
                    value={sensor.valores[0].value} 
                    displayType={'text'} 
                    allowNegative 
                    suffix={''} 
                    decimalScale={1}
                    decimalSeparator=","
                    fixedDecimalScale
                />;    
            case SensorType.TENSION:
                return <NumericFormat 
                    value={sensor.valores[0].value} 
                    displayType={'text'} 
                    allowNegative 
                    suffix={' V'} 
                />;
            case SensorType.CORRIENTE:
                return <NumericFormat 
                    value={sensor.valores[0].value} 
                    displayType={'text'} 
                    allowNegative 
                    suffix={' A'} 
                />;
            default:
                return null;
        }
    }
    else
    {
        switch (sensor.tipo_sensor) {
            case SensorType.TEMPERATURA:
                return <Typography
                    variant = "subtitle2" 
                    align="center"
                    color="primary"> 
                    --,- °C
                </Typography>
            case SensorType.PRESION:
                return <Typography
                    variant = "subtitle2" 
                    align="center"
                    color="primary"> 
                    --,- Kg
                </Typography>
            case SensorType.POTENCIA:
                return <Typography
                    variant = "subtitle2" 
                    align="center"
                    color="primary"> 
                    --- KW
                </Typography>
            case SensorType.COSENO_PHI:
                return <Typography
                    variant = "subtitle2" 
                    align="center"
                    color="primary"> 
                    -,-
                </Typography>
            case SensorType.TENSION:
                return <Typography
                    variant = "subtitle2" 
                    align="center"
                    color="primary"> 
                    --- v
                </Typography>
            case SensorType.CORRIENTE:
                return <Typography
                    variant = "subtitle2" 
                    align="center"
                    color="primary"> 
                    --- A
                </Typography>
            default:
                return null;
        }
    }

    }



    return (
        <Paper
            elevation={3}
            sx={{
                padding: 1,
                borderRadius: 2,
                backgroundColor: "#f5f5f5",
                textAlign: "center",
                height: "100%",
            }}
        >
        {
            propsSensor.valores?.length !== 0 ? (
                <>

                    <Typography 
                        variant = "caption" 
                    >
                        {propsSensor.name_front}
                        {/*<DeviceThermostatIcon  sx={{verticalAlign:"middle"}} /> */}
                        {/*getSensorIcon(propsSensor.tipo_sensor)*/}
                    </Typography>
                    <Tooltip 
                            title={`Ultima muestra: ${moment(propsSensor.valores[0].fecha_hora_value).format("DD/MM/YYYY HH:mm")}
                            Descirpcion: ${propsSensor.descripcion} `} 
                    >
                        <Typography 
                            component="div"
                            variant="h6" 
                            fontWeight="bold" 
                            color="primary"
                        >
                            {getValor(estado, propsSensor)}
                        </Typography>
                    </Tooltip>

                </>) : ("No hay sensores")
        }
        </Paper>
    )
}
